import axios from '../utils/ajax'
// 换电柜列表

export const deviceList = params => axios.get('/managementPlatform/thailand/deviceList',{params})
// 设备详情
export const wholeDeviceInfo = params => axios.get('/managementPlatform/thailand/wholeDeviceInfo',{params})
// 批量分配设备
export const distributeDevice = params => axios.get('/managementPlatform/thailand/distributeDevice',{params})
// 换电编辑回显图片
export const queryDevicePicture = params => axios.get('/managementPlatform/electricity/queryDevicePicture',{params})
// 换电柜口的停用功能
export const editChargePortEnableStatus = params => axios.get('/managementPlatform/electricity/editChargePortEnableStatus',{params})
// 电动车列表接口
export const queryThailandElectricBicycleList = params => axios.get('/managementPlatform/thailand/queryThailandElectricBicycleList',{params})
// 电瓶车详情接口
export const queryThailandElectricBicycleDetail = params => axios.get('/managementPlatform/thailand/queryThailandElectricBicycleDetail',{params})

// 批量激活电瓶车
export const activateElectricBicycle = params => axios.get('/managementPlatform/thailand/activateElectricBicycle',{params})

// 解绑电瓶车用户
export const cleanThailandBicycleBelongUser = params => axios.get('/managementPlatform/thailand/cleanThailandBicycleBelongUser',{params})

// 电动车关联用户
export const bindBicycleBelongUser = params => axios.get('/managementPlatform/thailand/bindBicycleBelongUser',{params})

// 电动车操作接口（上锁，解锁）
export const thailandElectricBicycleOperate = params => axios.get('/managementPlatform/thailand/thailandElectricBicycleOperate',{params})

// 获取电动车图片
export const queryElectricBicyclePicture = params => axios.get('/managementPlatform/electricity/queryElectricBicyclePicture',{params})

// 编辑电动车信息
export const editThailandElectricBicycle = params => axios.post('/managementPlatform/electricity/editElectricBicycle',params)

// 设备电量查询
export const electricityStatistics = params => axios.get('/managementPlatform/thailand/electricityStatistics',{params})

// 设备电量统计导出
export const thailandExcelExport = params => axios.get('/managementPlatform/thailand/thailandExcelExport',{params})

// 操作电动车状态
export const electricBicycleOperate = params => axios.get('/managementPlatform/electricity/electricBicycleOperate',{params})

// 查询设备操作记录
export const queryOperationMaintenanceRecord = params => axios.get('/managementPlatform/electricity/queryOperationMaintenanceRecord',{params})

// 查询电动车详情
export const queryElectricBicycleDetail = params => axios.get('/managementPlatform/electricity/queryElectricBicycleDetail',{params})

// 厂商列表
export const queryDeviceManufacturerInfo = params => axios.get("/managementPlatform/electricity/queryDeviceManufacturerInfo", {params});

// 获取二维码
export const queryQrCode = params => axios.post("/managementPlatform/electricity/queryQrCode", params);



// WEBPACK FOOTER //
// ./src/api/deviceManagement.js